<!-- Simple Form Layout - All sections in one view -->
<div class="form-card">
  <!-- Leaf Pattern Decoration -->
  <div class="form-card--leaf-pattern">
    <img src="/assets-leaf.png" alt="" class="form-card--leaf-image" />
  </div>
  
  <form [formGroup]="dataProviderEntityForm" class="data-provider-entity-form">
    
    <!-- Join Request View - Only 5 fields -->
    <ng-container *ngIf="isJoinRequest">
      <div class="form-section">
        <h3 class="section-title">User Details</h3>
        <div class="form-grid">
          <!-- User Name (combined from firstName + lastName) -->
          <div class="form-field">
            <label for="userName" class="form-label">
              User Name
            </label>
            <input
              type="text"
              id="userName"
              [value]="fullUserName"
              class="form-input input-disabled"
              placeholder="User name"
              readonly
            />
          </div>

          <!-- Registered Email -->
          <div class="form-field">
            <label for="registeredEmail" class="form-label">
              Registered Email
            </label>
            <input
              type="email"
              id="registeredEmail"
              formControlName="registeredEmail"
              class="form-input input-disabled"
              placeholder="Email address"
            />
          </div>

          <!-- Organisation Name -->
          <div class="form-field">
            <label for="entityName" class="form-label">
              Organisation Name
            </label>
            <input
              type="text"
              id="entityName"
              formControlName="entityName"
              class="form-input input-disabled"
              placeholder="Enter Organisation"
            />
          </div>

          <!-- Job Title -->
          <div class="form-field">
            <label for="jobTitle" class="form-label">
              Job Title
            </label>
            <input
              type="text"
              id="jobTitle"
              formControlName="jobTitle"
              class="form-input input-disabled"
              placeholder="e.g., Data Manager"
            />
          </div>

          <!-- Employee ID -->
          <div class="form-field">
            <label for="employeeId" class="form-label">
              Employee ID
            </label>
            <input
              type="text"
              id="employeeId"
              formControlName="employeeId"
              class="form-input input-disabled"
              placeholder="Enter your employee ID"
            />
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Create Request View - All fields -->
    <ng-container *ngIf="!isJoinRequest">
      <!-- User Details Section -->
      <div class="form-section">
        <h3 class="section-title">User Details</h3>
        <div class="form-grid">
          <!-- First Name -->
          <div class="form-field">
            <label for="firstName" class="form-label">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              formControlName="firstName"
              class="form-input input-disabled"
              placeholder="First name"
            />
          </div>

          <!-- Last Name -->
          <div class="form-field">
            <label for="lastName" class="form-label">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              formControlName="lastName"
              class="form-input input-disabled"
              placeholder="Last name"
            />
          </div>

          <!-- Registered Email -->
          <div class="form-field">
            <label for="registeredEmail" class="form-label">
              Registered Email
            </label>
            <input
              type="email"
              id="registeredEmail"
              formControlName="registeredEmail"
              class="form-input input-disabled"
              placeholder="Email address"
            />
          </div>

          <!-- Job Title -->
          <div class="form-field">
            <label for="jobTitle" class="form-label">
              Job Title
            </label>
            <input
              type="text"
              id="jobTitle"
              formControlName="jobTitle"
              class="form-input input-disabled"
              placeholder="e.g., Data Manager"
            />
          </div>

          <!-- Employee ID -->
          <div class="form-field">
            <label for="employeeId" class="form-label">
              Employee ID
            </label>
            <input
              type="text"
              id="employeeId"
              formControlName="employeeId"
              class="form-input input-disabled"
              placeholder="Enter your employee ID"
            />
          </div>
        </div>
      </div>

      <!-- Provider Entity Details Section -->
      <div class="form-section">
        <h3 class="section-title">Provider Entity Details</h3>
      <div class="form-grid">
        <!-- Entity Type -->
        <div class="form-field">
          <label for="entityType" class="form-label">
            Entity Type
          </label>
          <input
            type="text"
            id="entityType"
            formControlName="entityType"
            class="form-input input-disabled"
            placeholder="Entity type"
            readonly
          />
        </div>

        <!-- Entity Sector -->
        <div class="form-field">
          <label for="entitySector" class="form-label">
            Entity Sector
          </label>
          <input
            type="text"
            id="entitySector"
            formControlName="entitySector"
            class="form-input input-disabled"
            placeholder="Entity sector"
            readonly
          />
        </div>

        <!-- Entity Name -->
        <div class="form-field">
          <label for="entityName" class="form-label">
            Name of an Organisation
          </label>
          <input
            type="text"
            id="entityName"
            formControlName="entityName"
            class="form-input input-disabled"
            placeholder="Enter Organisation"
          />
        </div>

        <!-- Website URL -->
        <div class="form-field">
          <label for="websiteUrl" class="form-label">
            Website URL
          </label>
          <input
            type="url"
            id="websiteUrl"
            formControlName="websiteUrl"
            class="form-input input-disabled"
            placeholder="https://example.com"
          />
        </div>

        <!-- Address -->
        <div class="form-field">
          <label for="address" class="form-label">
            Address
          </label>
          <textarea
            id="address"
            formControlName="address"
            class="form-input form-textarea input-disabled"
            placeholder="Enter complete address"
            rows="3"
          ></textarea>
        </div>
      </div>
    </div>

      <!-- Document Upload Section -->
      <div class="form-section">
        <h3 class="section-title">Document Upload</h3>
      <div class="documents-grid">
        <!-- Firm Incorporation Certificate -->
        <div class="document-field">
          <label class="document-label">
            Firm Incorporation Certificate
          </label>
          <div class="file-display-area">
            <div class="file-display" *ngIf="documentFiles['incorporation']">
              <span class="file-name">{{ trimFileName(documentFiles['incorporation']) }}</span>
              <button
                *ngIf="documentPaths['incorporation']"
                type="button"
                class="pdf-preview-icon"
                [class.loading]="documentLoadingStates['incorporation']"
                [disabled]="documentLoadingStates['incorporation']"
                (click)="openPdfPreview('incorporation')"
                title="Preview PDF"
              >
                <svg *ngIf="!documentLoadingStates['incorporation']" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="documentLoadingStates['incorporation']" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                    <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                    <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                  </circle>
                </svg>
              </button>
            </div>
            <div class="file-display-empty" *ngIf="!documentFiles['incorporation']">
              <span class="no-file-text">No file uploaded</span>
            </div>
          </div>
        </div>

        <!-- PAN Card -->
        <div class="document-field">
          <label class="document-label">
            PAN Card
          </label>
          <div class="file-display-area">
            <div class="file-display" *ngIf="documentFiles['panCard']">
              <span class="file-name">{{ trimFileName(documentFiles['panCard']) }}</span>
              <button
                *ngIf="documentPaths['panCard']"
                type="button"
                class="pdf-preview-icon"
                [class.loading]="documentLoadingStates['panCard']"
                [disabled]="documentLoadingStates['panCard']"
                (click)="openPdfPreview('panCard')"
                title="Preview PDF"
              >
                <svg *ngIf="!documentLoadingStates['panCard']" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="documentLoadingStates['panCard']" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                    <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                    <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                  </circle>
                </svg>
              </button>
            </div>
            <div class="file-display-empty" *ngIf="!documentFiles['panCard']">
              <span class="no-file-text">No file uploaded</span>
            </div>
          </div>
        </div>

        <!-- Letter of Authorization -->
        <div class="document-field">
          <label class="document-label">
            Letter of Authorization
          </label>
          <div class="file-display-area">
            <div class="file-display" *ngIf="documentFiles['authorization']">
              <span class="file-name">{{ trimFileName(documentFiles['authorization']) }}</span>
              <button
                *ngIf="documentPaths['authorization']"
                type="button"
                class="pdf-preview-icon"
                [class.loading]="documentLoadingStates['authorization']"
                [disabled]="documentLoadingStates['authorization']"
                (click)="openPdfPreview('authorization')"
                title="Preview PDF"
              >
                <svg *ngIf="!documentLoadingStates['authorization']" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="documentLoadingStates['authorization']" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                    <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                    <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                  </circle>
                </svg>
              </button>
            </div>
            <div class="file-display-empty" *ngIf="!documentFiles['authorization']">
              <span class="no-file-text">No file uploaded</span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </ng-container>
  </form>
</div>

<!-- PDF Preview Modal -->
<app-modal
  [(visible)]="showPdfPreviewModal"
  [header]="currentPdfTitle"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closePdfPreview()"
>
  <div class="pdf-preview-container">
    <!-- Loading state -->
    <div *ngIf="pdfLoading" class="pdf-loading">
      <div class="loading-spinner"></div>
      <p>Loading PDF...</p>
    </div>
    
    <!-- PDF Viewer -->
    <pdf-viewer
      *ngIf="!pdfLoading && currentPdfUrl"
      [src]="currentPdfUrl"
      [render-text]="true"
      [original-size]="false"
      [show-all]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="true"
      style="width: 100%; height: 100%;"
    ></pdf-viewer>
    
    <!-- Error state -->
    <div *ngIf="!pdfLoading && !currentPdfUrl" class="pdf-error">
      <p>Unable to load PDF. Please try again.</p>
    </div>
  </div>
</app-modal>
